<ng-template #content_receipt_options let-offcanvas>
    <div class="{{localService.selectedLanguageCode}}"
        *ngIf="localService.languageContent && localService.languageContent.seller">
        <div class="side_popup_header">
            <span>{{localService.languageContent.seller.receipt_options}}</span>
            <button class="button_icon" (click)="onCloseTrigger()">close</button>
        </div>
        <div class="row">
            <div class="col-12">
                <input autocomplete="off" type="text" style="margin-bottom: 10px;width: calc(100% - 50px);"
                    [(ngModel)]="searchKey" title="{{localService.languageContent.common.search}}"
                    id="{{elementIds.txt_search_key}}" placeholder="{{localService.languageContent.common.search}}"
                    (input)="onAction(1)" />
                <button class="button_icon button_icon_color icon_adjust" style="margin-left: 10px;"
                    (click)="onAction(5)">swap_vertical_circle</button>
            </div>
        </div>
        <div class="side_popup_body" [ngStyle]="{'max-height' : (localService.sideBarBodyHeight - 55) + 'px'}"
            *ngIf="localService.receiptOptions">
            <div class="row styled_row" *ngFor="let item of receiptOptions">
                <div class="col-12" [ngClass]="item.isInActive ? 'disabled': ''">
                    <label style="margin-left:20px;font-weight:normal;" title="{{item.value + ' - ' +  item.key}}">
                        <input type="checkbox" [(ngModel)]="item.isSelected" (change)="onAction(3,item.key)" [disabled]="item.isInActive">
                        <span class="en" *ngIf="!isSortByName">&nbsp;{{item.key}} - </span>
                        <span style="color:darkslategrey">&nbsp;{{item.value}}</span>
                        <span class="en" *ngIf="isSortByName" style="opacity: 0.5;font-style: italic;">&nbsp;{{item.key}}</span>
                    </label>
                </div>
            </div>
        </div>
        <div class="side_popup_footer">
            <div class="row">
                <div class="col-6">
                    <ngx-select id="{{elementIds.dd_print_language}}" [isFocused]="true"
                        [(ngModel)]="printingLanguageId" [noAutoComplete]="true"
                        [items]="localService.Sort(localService.languagesEquivalent,true,'v3')"
                        [optionValueField]="'v1'" [optionTextField]="'v3'" class="dropdown-at-bottom"></ngx-select>
                </div>
                <div class="col-2">
                    <button class="button_icon button_icon_color icon_adjust" (click)="onAction(4)">print</button>
                </div>
                <div class="col-4">
                    <button type="button" class="btn btn-primary"
                        (click)="onAction(2)">{{localService.languageContent.common.save}}</button>
                </div>
            </div>
        </div>
    </div>
</ng-template>
<div>
    <app-print-receipt *ngIf="isPrint" [IsSample]="true" [IsPrint]="isPrint" [receiptType]="receiptType"
        (onPrinted)="onPrinted()" [printingLanguage]="printingLanguageId"
        [selectedReceiptOptionsForPrint]="selectedReceiptOptionsForPrint"></app-print-receipt>
</div>